import { Pipe, PipeTransform } from '@angular/core';
import { trackByProperty } from '../functions';

@Pipe({
    name: 'cmTrackByProperty',
    pure: true,
    standalone: false
})
export class AtsTrackByPropertyPipe implements PipeTransform {
	public transform(propertyNames: '$index'): any;
	public transform(propertyNames: string[]): any;
	public transform(propertyNames: string): any;
	public transform(propertyNames: any): any {
		return trackByProperty(propertyNames);
	}
}
